enum EMacroFiltroExecucao {
  Indefinido = '-',
  MomentoDaExecucao = 'MOMENTO_DA_EXECUCAO',
  Anteontem = 'ANTEONTEM',
  Ontem = 'ONTEM',
  Hoje = 'HOJE',
  Amanha = 'AMANHA',
  DiaAtual = 'DIA_ATUAL',
  DiaAnterior = 'DIA_ANTERIOR',

  AnoAnterior = 'ANO_ANTERIOR',
  AnoAtual = 'ANO_ATUAL',
  AnoPosterior = 'ANO_POSTERIOR',

  InicioMesAtual = 'INICIO_MES_ATUAL',
  FimMesAtual = 'FIM_MES_ATUAL',
  MesAtual = 'MES_ATUAL',
  MesAnterior = 'MES_ANTERIOR',

  InicioCincoAnosAtras = 'INICIO_DE_CINCO_ANOS_ATRAS',
  InicioDezAnosAtras = 'INICIO_DE_DEZ_ANOS_ATRAS',

  InicioAnoAnterior = 'INICIO_ANO_ANTERIOR',
  FimAnoAnterior = 'FIM_ANO_ANTERIOR',
  InicioAnoAtual = 'INICIO_ANO_ATUAL',
  FimAnoAtual = 'FIM_ANO_ATUAL',
  InicioAnoPosterior = 'INICIO_ANO_POSTERIOR',
  FimAnoPosterior = 'FIM_ANO_POSTERIOR',
}

export default EMacroFiltroExecucao;
